// extracted by mini-css-extract-plugin
export default {"entityLink":"paperJournalAdminLinks_entityLink__Nkay9","mono":"paperJournalAdminLinks_mono__qp+oX"};